module.exports = __webpack_public_path__ + "static/img/定制服务成功案例.c0f4c6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/定制服务成功案例.png
// module id = Z8sU
// module chunks = 3